import PropTypes from 'prop-types'
import {Image} from '@chakra-ui/react'

import AnzLogo from '../../../../assets/images/banking_provider_logos/anz_logo.svg'
import WestpacLogo from '../../../../assets/images/banking_provider_logos/westpac_logo.svg'
import NabLogo from '../../../../assets/images/banking_provider_logos/nab_logo.svg'
import CommonwealthLogo from '../../../../assets/images/banking_provider_logos/commonwealth_bank_logo.svg'
import DefaultLogo from '../../../../assets/images/banking_provider_logos/default_logo.svg'

const bankLogos = {
  ANZ: AnzLogo,
  'Commonwealth Bank': CommonwealthLogo,
  'NAB Connect': NabLogo,
  'NAB Internet': NabLogo,
  Westpac: WestpacLogo,
}

const BankLogo = ({providerName}) => (
  <Image
    src={bankLogos[providerName || ''] || DefaultLogo}
    maxW="60px"
    maxH="30px"
    alt={providerName}
  />
)

BankLogo.defaultProps = {
  providerName: null,
}

BankLogo.propTypes = {
  providerName: PropTypes.string,
}

export default BankLogo
